export default "__VITE_ASSET__4SnfoQTS__"